<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import type { FrequentlyAskedQuestionsProps } from "./FrequentlyAskedQuestionsProps.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import Branches from "../components/Branches.svelte";
	import ProductCard from "../components/Product/ProductCard.svelte";
	import FrequentlyAskedQuestion from "../components/FrequentlyAskedQuestion.svelte";

	type $$Props = FrequentlyAskedQuestionsProps;

	const { frequentlyAskedQuestions, recommendedProducts } = $$restProps as $$Props;

	let openIndex: number | null = null;

	function toggleFaq(index: number): void {
		if (openIndex === index) {
			openIndex = null;
		} else {
			openIndex = index;
		}
	}

	// eslint-disable-next-line no-warning-comments
	// FIXME remove this after upgrade to Svelte 5.
	/* eslint-disable @typescript-eslint/explicit-function-return-type */
</script>

<Layout>
	<div class="container">
		<div class="mt-6 flex flex-col items-center gap-8 md:mt-10">
			<span class="md:text-md text-center text-base font-semibold uppercase leading-7 tracking-[0.9375rem]">
				Máte otázku?
			</span>
			<h1 class="m-0 p-0 text-center text-[1.8rem] font-semibold leading-10 md:text-2xl lg:mt-0 lg:leading-[4.25rem]">
				{nbspify("Odpovědi na časté dotazy")}
			</h1>
		</div>

		<section class="mt-10 flex flex-col gap-4 md:mt-14 xl:px-[11.5rem]">
			{#each frequentlyAskedQuestions as { question, answer, anchor }, index}
				<FrequentlyAskedQuestion
					{question}
					{answer}
					{anchor}
					isOpen={openIndex === index}
					onClick={() => {
						toggleFaq(index);
					}}
				/>
			{/each}
		</section>
	</div>

	<div class="container">
		<section class="container">
			{#if recommendedProducts.length > 0}
				<h2 class="md:text-md text-center text-base font-semibold uppercase leading-7 tracking-[0.9375rem]">
					Doporučujeme
				</h2>
				<div class="product-card-wrapper mt-6 lg:mt-8">
					{#each recommendedProducts as product (product.id)}
						<ProductCard {product} />
					{/each}
				</div>
			{/if}
		</section>

		<section>
			<Branches />
		</section>
		<div class="flex w-full justify-center">
			<span class="max-w-[35rem] text-center text-lg font-semibold md:text-2xl md:leading-[4.25rem]"
				>Těšíme se<br />na vaši návštěvu!</span
			>
		</div>
	</div>
</Layout>
